﻿﻿export interface IBillingReportItems {
    physicianCharge: number;
    physicianChargeStatus: string;
    physicianChargeComments: string;
    anesthesiaCharge: number;
    anesthesiaChargeStatus: string;
    anesthesiaChargeComments: string;
    hospitalCharge: number;
    hospitalChargeStatus: string;
    hospitalChargeComments: string;
}
